module.exports = __webpack_public_path__ + "img/f.a45b7a3d.jpg";